import { Routes } from "@angular/router";

export const investmentOptionsLazyRoutes: Routes = [
  {
    path: "",
    loadComponent: () => import("./investment-options-page.component").then((c) => c.InvestmentOptionsPageComponent),
  },
];
